module.exports = __webpack_public_path__ + "img/sao-paulo.768f4756.jpg";